import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X } from "lucide-react";
import { getStoredUtm } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { trackLead } from "@/lib/metaPixel";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const STORAGE_KEY = "duds.popup.dismissed.v1";

const EmailPopup = () => {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Don't pester logged-in customers — they already gave us their email.
    if (isAuthenticated) return;
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setOpen(true), 12000);
    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  // If the user logs in while the popup is open, close it.
  useEffect(() => {
    if (isAuthenticated && open) setOpen(false);
  }, [isAuthenticated, open]);

  const close = () => {
    setOpen(false);
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("That email is sourer than our shirts.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/newsletter`, {
        email,
        source: "popup",
        utm: getStoredUtm(),
      });
      trackLead({ content_name: "newsletter-popup", currency: "AUD" });
      toast.success("Filed. 10% off code on its way (if we remember).");
      close();
    } catch (e) {
      console.warn("[newsletter] signup failed:", e);
      toast.success("Filed. (Probably.)");
      close();
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-[#1C1914]/60 flex items-end md:items-center justify-center p-4" data-testid="email-popup">
      <div className="relative w-full max-w-md border-4 border-[#1C1914] bg-[#FDE047] shadow-hard-lg p-6 md:p-8">
        <button
          type="button"
          onClick={close}
          className="absolute top-3 right-3 border-2 border-[#1C1914] p-1.5 hover:bg-[#FFFDF5]"
          aria-label="Close"
          data-testid="email-popup-close"
        >
          <X size={16} />
        </button>
        <p className="font-condensed text-sm uppercase tracking-widest text-[#1C1914]">// One time offer (probably)</p>
        <h3 className="font-display text-3xl md:text-4xl uppercase mt-2 leading-none">
          10% off your first regret.
        </h3>
        <p className="font-body text-sm mt-3 text-[#1C1914]/80">
          Drop your email and we'll text you when shirts arrive. Unsubscribe whenever, we won't notice.
        </p>
        <form onSubmit={submit} noValidate className="mt-4 flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your-saddest@email.com"
            className="input-duds bg-[#FFFDF5]"
            data-testid="email-popup-input"
            required
          />
          <button type="submit" disabled={submitting} className="btn-duds" data-testid="email-popup-submit">
            {submitting ? "…" : "Beg us"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailPopup;
